const addDotLinksAndClickHandlers = (emblaApi, dotsNode) => {
  let dotNodes = [];

  const addDotLinksWithClickHandlers = () => {
    dotsNode.innerHTML = emblaApi
      .scrollSnapList()
      .map(() => '<button class="embla__dot" type="button"></button>')
      .join('');

    const scrollTo = (index) => {
      emblaApi.scrollTo(index);
    };

    dotNodes = Array.from(dotsNode.querySelectorAll('.embla__dot'));
    dotNodes.forEach((dotNode, index) => {
      dotNode.addEventListener('click', () => scrollTo(index), false);
    });
  };

  const toggleDotLinksActive = () => {
    const previous = emblaApi.previousScrollSnap();
    const selected = emblaApi.selectedScrollSnap();
    dotNodes[previous].classList.remove('embla__dot--selected');
    dotNodes[selected].classList.add('embla__dot--selected');
  };

  emblaApi
    .on('init', addDotLinksWithClickHandlers)
    .on('reInit', addDotLinksWithClickHandlers)
    .on('init', toggleDotLinksActive)
    .on('reInit', toggleDotLinksActive)
    .on('select', toggleDotLinksActive);

  return () => {
    dotsNode.innerHTML = '';
  };
};

export default addDotLinksAndClickHandlers;
